// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Components
import MessageModal from '../../shared/components/MessageModal';

// Actions
import { fetchFeedbackCategories, sendFeedback } from '../actions';

// Assets
import './ContactUsMenu.css';

// Shapes
import { feedbackStatusShape } from '../propTypesShapes';
import { profileShape } from '../../authentication/propTypesShapes';


class ContactUsMenu extends React.PureComponent {
  static propTypes = {
    token: PropTypes.string,
    profile: profileShape,
    feedbackCategories: PropTypes.arrayOf(PropTypes.string),
    feedback: feedbackStatusShape
  };

  constructor(props) {
    super(props);

    this.state = {
      company: '',
      firstName: '',
      lastName: '',
      emailAddress: '',
      topicCategory: '',
      comments: '',
      isOpenMessageModal: false
    };

    this.handleOnSubmit = this.handleOnSubmit.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleOnCloseMessageModal = this.handleOnCloseMessageModal.bind(this);
  }

  componentDidMount() {
    const { token, feedbackCategories, dispatch } = this.props;

    if ( token && !feedbackCategories ) {
      dispatch(fetchFeedbackCategories(token));
    }
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const { feedback } = newProps;

    if (feedback.wasSent !== this.props.feedback.wasSent && feedback.wasSent) {
      this.setState({
        company: '',
        firstName: '',
        lastName: '',
        emailAddress: '',
        topicCategory: '',
        comments: '',
        isOpenMessageModal: true
      });
    }
  }

  handleOnSubmit(event) {
    const { token, profile, dispatch } = this.props;
    const { company, firstName, lastName, emailAddress, topicCategory, comments } = this.state;
    const profileData = profile.data;
    const feedback = {
      id: profileData.id,
      appuserid: profileData.appUserId,
      firstName,
      lastName,
      emailAddress,
      topicCategory,
      comments // , addDate it is not necessary (format 2018-10-02T05:21:43.511Z)
    };

    event.preventDefault();

    if (company) {
      feedback.company = company;
    }

    dispatch(sendFeedback(token, feedback));
  }

  handleOnChange(event) {
    const { id, value } = event.target;
    this.setState({ [id]: value });
  }

  handleOnCloseMessageModal() {
    this.setState({ isOpenMessageModal: false });
  }

  render() {
    const { feedbackCategories, className = '' } = this.props;
    const {
      company, firstName, lastName,
      emailAddress, topicCategory, comments,
      isOpenMessageModal
    } = this.state;

    return (
      <div className={`ContactUsMenu ${className}`}>
        <form onSubmit={this.handleOnSubmit}>
          <div className="form-group">
            <label htmlFor="company">Company</label>
            <input className="form-control"
              id="company"
              type="text"
              value={company}
              onChange={this.handleOnChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="firstName">First Name</label>
            <input className="form-control"
              id="firstName"
              type="text"
              required
              value={firstName}
              onChange={this.handleOnChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="lastName">Last Name</label>
            <input className="form-control"
              id="lastName"
              type="text"
              required
              value={lastName}
              onChange={this.handleOnChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="emailAddress">Email Address</label>
            <input className="form-control"
              id="emailAddress"
              type="email"
              required
              value={emailAddress}
              onChange={this.handleOnChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="topicCategory">Topic Category</label>
            <select className="form-control"
              id="topicCategory"
              required
              value={topicCategory}
              onChange={this.handleOnChange}
            >
              <option value="">Select Topic</option>
              {feedbackCategories && feedbackCategories.map((topic, index) =>
                <option key={index} value={topic}>
                  {topic}
                </option>
              )}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="comments">Comments</label>
            <textarea className="form-control"
              id="comments"
              required
              rows="3"
              value={comments}
              onChange={this.handleOnChange}
            />
          </div>

          <button type="submit" className="btn">Submit</button>
        </form>

        <MessageModal
          isOpen={isOpenMessageModal}
          message="Your feedback has been sent!"
          onRequestClose={this.handleOnCloseMessageModal}
        />
      </div>
    );
  }
}

export default connect(({ authentication, settings }) => ({
  token: authentication.token,
  profile: authentication.profile,
  feedbackCategories: settings.feedbackCategories,
  feedback: settings.feedback
}), null)(ContactUsMenu);
